import _ from 'underscore';
import Chart from 'chartjs';
import moment from 'moment';
import i18n from 'l10n';
import ch from 'libs/chart-helpers';

export class RedemptionsChartView {
    /**
     * Constructor
     * @param {jQuerySelector} selector
     * @param {Number} userId
     * @returns {Promise<void>}
     */
    constructor(selector, userId) {
        this.pingUrl = '/CampaignCloud/UserInfo';
        this.isPostpaid = false;
        this.options = {
            userId: userId,
            from: null, //moment
            to: null, //moment
            window: null,
            fromAll: null,
            toAll: null,
            unitAll: null,
            queryOptions: {
                from: null, //long millis
                to: null, //long millis
                unit: null,
                window: null,
                dow: moment().localeData().firstDayOfWeek()
            }
        };
        this.division = {
            all: {divisions: ['month'], def: 'month'},
            day: {divisions: ['hour'], def: 'hour'},
            week: {divisions: ['day'], def: 'day'},
            month: {divisions: ['week', 'day'], def: 'day'},
            year: {divisions: ['month', 'week'], def: 'month'}
        };
        this.selector = selector;
    }

    moreLessDetails(inc) {
        var division = this.division[this.options.window];
        var curr = _.indexOf(division.divisions, this.options.queryOptions.unit);
        if (curr >= 0 && curr + inc >= 0 && curr + inc < division.divisions.length) { //paranoid check
            this.options.queryOptions.unit = division.divisions[curr + inc];
            $(this.selector).find(".zoom-buttons").find('button').removeClass('disabled');
            if (this.options.queryOptions.unit === _.first(division.divisions)) {
                $(this.selector).find(".zoom-buttons").find('.minus').addClass('disabled');
            } else if (this.options.queryOptions.unit === _.last(division.divisions)) {
                $(this.selector).find(".zoom-buttons").find('.plus').addClass('disabled');
            }
            this.refresh();
        }
    }

    setWindow(timegranule) {
        var now = moment();
        var previousWindow = this.options.window;
        var goingToDayFromEnclosingWindow = this.options.window !== 'day' && timegranule === "day" && now.isBetween(this.options.from, this.options.to);
        if (timegranule === "*day") timegranule = "day";

        this.options.window = timegranule;
        this.options.queryOptions.window = timegranule;
        var division = this.division[timegranule];
        this.options.queryOptions.unit = division.def;
        const singleDivision = division.divisions.length === 1;
        if (!singleDivision) {
            if (this.options.queryOptions.unit === _.first(division.divisions)) {
                $(this.selector).find(".zoom-buttons").find('.minus').addClass('disabled');
            } else if (this.options.queryOptions.unit === _.last(division.divisions)) {
                $(this.selector).find(".zoom-buttons").find('.plus').addClass('disabled');
            }
        }
        $(this.selector).find(".zoom-buttons").find('button').toggleClass('disabled', singleDivision);
        const isAll = timegranule === 'all';
        if (isAll) {
            this.options.queryOptions.unit = this.options.unitAll;
            this.options.from = this.options.fromAll;
            this.options.to = this.options.toAll;
            this.options.queryOptions.from = this.options.from.toDate().getTime();
            this.options.queryOptions.to = this.options.to.toDate().getTime();
            $(this.selector).find('.pagination').find('.spaces').html(i18n.t('reports.allbutton'));
        } else {
            const startOf = previousWindow !== 'month' && goingToDayFromEnclosingWindow
                ? now.startOf("day")
                : this.options.from.clone().startOf(this.options.window);
            this.options.from = startOf;
            this.options.queryOptions.from = startOf.toDate().getTime();
            var endOf = startOf.clone().endOf(this.options.window);
            this.options.to = endOf;
            this.options.queryOptions.to = endOf.toDate().getTime();

            var startOfString = startOf.format('ll');
            var endOfString = endOf.format('ll');
            $(this.selector).find('.pagination').find('.spaces').html(`${startOfString} - ${endOfString}`);
        }
        $(this.selector).find('.pagination').find('li').toggleClass('disabled', isAll);
    }

    async init() {

        const {creationDate, postpaid} = await $.ajaxDefaultQ({
            url: this.pingUrl,
            type: 'GET',
            contentType: 'application/json',
            dataType: 'json'
        });

        const dateFrom = moment(creationDate.millis).startOf('month');
        const millisOfDay = 1000 * 60 * 60 * 24;
        this.options.fromAll = dateFrom;
        var now = moment().toDate().getTime();
        this.options.toAll = moment().endOf('month');
        var diff = now - dateFrom;

        // Convert back to days and check
        const diffRatio = Math.round(diff / millisOfDay);
        if (diffRatio < 30) this.options.unitAll = "day";
        else if (diffRatio < 49) this.options.unitAll = "week";
        else this.options.unitAll = "month";

        this.isPostpaid = postpaid;

        this.setWindow('all');
        await this.refresh();
    }

    render() {
        if (!this.data) this.init();
        else {
            const $el = $(this.selector);
            if (this.chart) this.chart.destroy();

            const labels = i18n.labels(this.options.from, this.options.window, this.options.queryOptions.unit, this.data.redemptions.length);
            const data = {
                labels: labels,
                datasets: [
                    {
                        label: i18n.t('engagement.vouchersRedeemed'),
                        fillColor: ch.colors.mauveUno.transparent,
                        strokeColor: ch.colors.mauveUno.solid,
                        pointColor: ch.colors.mauveUno.solid,
                        pointStrokeColor: "#fff",
                        pointHighlightFill: "#fff",
                        pointHighlightStroke: ch.colors.mauveUno.solid,
                        data: this.data.redemptions
                    }
                ]
            };
            var options = {
                bezierCurve: false,
                datasetFill: true,
                responsive: true,
                legendTemplate: '<% %><div style="text-align:center;"><% for (var i=0; i<datasets.length; i++){%><span style="margin:0 10px 0 10px;text-align:center"><span style="background-color:<%=datasets[i].strokeColor%>; width:15px; height:10px; display:inline-block"></span><%if(datasets[i].label){%> <span style="font-size:7pt;" class="text-bold"><%=datasets[i].label%><%}%></span</span><%}%></div><% %>'
            };

            var canvas = $el.find('#redemptionsChart').get(0);
            var ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            this.chart = new Chart(ctx).Bar(data, options);

            var legend = this.chart.generateLegend();

            $el.find(".timegranule-buttons").find(`[data-timegranule='${this.options.window}']`).addClass('active');
            $el.find('#redemptionsLegend').html(legend).click(() => ch.exportHandler(this.chart));
            $el.find('#redemptionsChart').unbind("click").bind("click", evt => {
                if (this.options.window !== "day") {
                    var ord = ch.getOrdinalPositionOfEvent(this.chart, evt);

                    //ChartJS, returns -1 if not BAR/LINE clicked
                    //-1 means that the selected date has no data to display
                    if (ord === -1) {
                        return;
                    }

                    this.setWindow(this.goSmaller(this.options.window));
                    $el.find(".timegranule-buttons").find("[data-timegranule]").removeClass('active');
                    $el.find(".timegranule-buttons").find(`[data-timegranule='${this.options.window}']`).addClass('active');
                    this.options.from.add(ord, `${this.options.window}s`);
                    this.setWindow(this.options.window);
                    this.refresh();
                }
            });
        }
    }

    async refresh() {

        try {
            const response = await $.ajaxDefaultQ({
                url: '/CampaignCloud/RememberMeController/ping',
                type: 'GET',
                dataType: "json"
            });
            if (response.status !== 'success') throw response;
        } catch (e) {
            console.info(e);
            window.open('Login.htm', '_self');
        }
        try {
            console.log(`Going to ${this.options.from.format('ll')}(${this.options.queryOptions.from}) - ${this.options.to.format('ll')}(${this.options.queryOptions.to}) window=${this.options.window} unit=${this.options.queryOptions.unit} dow=${this.options.queryOptions.dow}`);

            this.data = await $.ajaxDefaultQ({
                url: `/CampaignCloud/Report/redeemers/${this.options.userId}/voucherRedemptionChart`,
                type: 'POST',
                data: JSON.stringify(this.options.queryOptions),
                contentType: 'application/json',
                dataType: 'json'
            });
            this.render();
        }
        catch (e) {
            console.log(e);
        }
    }

    goSmaller(timegranule) {
        switch (timegranule) {
            case "week":
                return "day";
            case "month":
                return "day";
            case "year":
                return "month";
            case "all":
                return this.options.unitAll === "day" ? "*day" : this.options.unitAll;
        }
        return null;
    }
}
